import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Helper } from "../../core/util/helper";
import React from "react";
export default class NotAllowedDocumentTypes extends React.Component<NotAllowedDocumentTypesProps, any>{
    private buttons: Array<ToolBarStandardButton> = [
        {
            caption: Config.translations.newLabel,
            type: ToolBarStandardButtonType.NEW,
            enabled: true
        },
        {
            caption: Config.translations.deleteLabel,
            type: ToolBarStandardButtonType.DELETE,
            enabled: true
        }
    ];

    private gridOptions: kendo.ui.GridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: true,
        selectable: true,
        resizable: true,
        scrollable: true,
        columns: [
            {
                title: Helper.getTranslation("Dokument.FileTypes"),
                field: "Value"
            }
        ]
    };

    constructor(props) {
        super(props)
    }

    private onChange = (values: string[]) => {
        values = values.map((value) => {
            let arr = value.split('.');
            arr = arr.filter(v => !Helper.isNullOrEmpty(v));
            return arr.join('.').toLowerCase();
        }).sort((a, b) => {
            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }
            return 0;
        });

        values = [...new Set(values)];

        this.props.onChange(this.props.field, values);
    }

    private renderGrid = () => {
        return (
            <div className="flex-container">
                <Grid
                    data={this.props.value.map(v => { return {Value: v} })}
                    options={this.gridOptions}
                    id="ticketTypes"
                    standardButtons={this.buttons}
                    onClickStandardButton={this.onButtonClick}
                />
            </div>
        );
    }

    private onButtonClick = async (type: ToolBarStandardButtonType, dataItem) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                const newValue = await DialogHelper.prompt(Helper.getTranslation("Dokument.EnterDocType"));
                if (!Helper.isNullOrEmpty(newValue)) {
                    const values = this.props.value;
                    values.push(newValue);
                    this.onChange(values);
                }
                break;
            case ToolBarStandardButtonType.DELETE:
                const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"))
                if (isOk) {
                    const values = this.props.value.filter(f => f.toLowerCase() != dataItem.Value.toLowerCase());
                    this.onChange(values);
                }
                break;
        }
    }

    render() {
        return this.renderGrid();
    }
}

interface NotAllowedDocumentTypesProps {
    value: string[];
    onChange: (field, value) => void;
    field: any;
}